import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import HeadedChartLayout, { HeadedChartLayoutComponent } from 'components/layouts/HeadedChartLayout'

const LineChartLoadingOverlay = () => (
  <HeadedChartLayout>
    <HeadedChartLayoutComponent.PreloaderMarker>
      <LoadingOverlay />
    </HeadedChartLayoutComponent.PreloaderMarker>
  </HeadedChartLayout>
)

export default LineChartLoadingOverlay
